import { uiSurface } from "shared/ui/uiSurface"
import { Chip } from "@mui/material"
import { DataGrid, GridColDef } from "@mui/x-data-grid"
import { FC, useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Employee } from "../../apis/appApi"

type EmployeesGridProps = {
  rows: Employee[]
  loading: boolean
  onRowClick: (id: number) => void
}

export const EmployeesGrid: FC<EmployeesGridProps> = ({
  rows,
  loading,
  onRowClick,
}) => {
  const { t } = useTranslation()

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: "name",
        headerName: t("employees.lastName"),
        flex: 1,
        minWidth: 180,
        valueGetter: (_value, row) => `${row.lastName}, ${row.firstName}`,
      },
      {
        field: "username",
        headerName: t("employees.username"),
        flex: 1,
        minWidth: 150,
      },
      {
        field: "enabled",
        headerName: t("employees.status"),
        width: 100,
        renderCell: (params) => (
          <Chip
            label={
              params.value ? t("employees.active") : t("employees.disabled")
            }
            color={params.value ? "success" : "default"}
            size="small"
          />
        ),
      },
    ],
    [t],
  )

  const handleRowClick = useCallback(
    (params: any) => {
      onRowClick(params.id as number)
    },
    [onRowClick],
  )

  return (
    <DataGrid
      {...uiSurface("UI-DLV2-111")}
      data-testid="employees-grid"
      rows={rows}
      columns={columns}
      loading={loading}
      pageSizeOptions={[10, 25, 50]}
      initialState={{
        pagination: { paginationModel: { pageSize: 25 } },
      }}
      onRowClick={handleRowClick}
      disableRowSelectionOnClick
      sx={{
        border: 0,
        height: "100%",
        "& .MuiDataGrid-row": { cursor: "pointer" },
      }}
    />
  )
}
